import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/styles';


const styles = theme => ({
    barLabel: {
        fontSize: '7px'
    },
    barTitle: {
        width:'100%',
        textAlign:'left'
    },
    barNotch: {
        zIndex: '1000',
        position: 'relative',
        marginBottom: '-20px'
    },
    barDescription: {
        marginTop:'10px'
    }
    })
class RiskBar extends Component {

    constructor(props){
        super(props)
    }

    render() {
        let segments = []
        let selectedSegment = -1
        const {classes} = this.props;

        let marginOffset=0
        let barWidth = window.innerWidth > 436 ? 100 : 60
        let labelMargin = window.innerWidth > 436 ? '225px' : '105px'

        let value = this.props.content.IsInverted == "1" ? 100-parseInt(this.props.content.Value) : parseInt(this.props.content.Value)

        if(this.props.content.Segments.length){
            segments = this.props.content.Segments.map((segment, index) => {
                            if(selectedSegment < 0 && value <= parseInt(segment.UpperBounds)){
                                selectedSegment = index
                            }
                            return RiskSVG(segment.Color, barWidth)    
                            })
            if(selectedSegment == 0){
                if(barWidth==100){
                    marginOffset = -300 + calcStep(0, parseInt(this.props.content.Segments[0].UpperBounds), value, 180)

                } else {
                    marginOffset = -180 + calcStep(0, parseInt(this.props.content.Segments[0].UpperBounds), value, 100)

                }
            }
            if(selectedSegment == 1){
                if(barWidth==100){
                    marginOffset = -90 + calcStep(parseInt(this.props.content.Segments[0].UpperBounds), parseInt(this.props.content.Segments[1].UpperBounds), value, 180)

                } else {
                    marginOffset = -56 + calcStep(parseInt(this.props.content.Segments[0].UpperBounds), parseInt(this.props.content.Segments[1].UpperBounds), value, 106)

                }
                
            }
            if(selectedSegment == 2){
                if(barWidth==100){
                    marginOffset = 110 + calcStep(parseInt(this.props.content.Segments[1].UpperBounds), parseInt(this.props.content.Segments[2].UpperBounds), value, 180)

                } else {
                    marginOffset = 70 + calcStep(parseInt(this.props.content.Segments[1].UpperBounds), parseInt(this.props.content.Segments[2].UpperBounds), value, 70)

                }
            }
        }
        
        let notch = []
        if(1>0){
            notch = NotchSVG(this.props.content.Segments[selectedSegment].Label)
        }
        return(
            <Grid style={{textAlign:'left', marginTop:'', marginBottom:'20px'}}>

                <div style={{textAlign:'center'}}>

                    <div class={classes.barNotch} style={{marginLeft:marginOffset}}>
                        {notch}
                    </div>
                    
                    <div style={{zIndex:'-1'}}>
                        {segments}
                    </div>
                    <div class={classes.barLabel}>
                        <span style={{marginRight: labelMargin}}>
                            {'< ' + this.props.content.UpperBoundLabel}
                        </span>
                        <span>
                            {this.props.content.LowerBoundLabel + ' >'}
                        </span>
                    </div>
                    <div class={classes.barDescription}>
                        {this.props.content.Label}
                    </div>
                </div>
                
                
            </Grid>
        )
    }
}

export default withStyles(styles)(RiskBar)

function calcStep(min, max, value, width){
    return Math.floor(((value-min)*width)/(max-min))
}

function RiskSVG(color, width){
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height="29.638" viewBox="0 0 100 29.638" style={{margin:'2px'}}>
            <rect id="Rectangle_17" data-name="Rectangle 17" width="100" height="29.638" rx="3" fill={color}/>
        </svg>

    )
}

function NotchSVG(text){
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="44.58" viewBox="0 0 41 44.58">
          <g id="Group_170" data-name="Group 170" transform="translate(-615.571 -221.778)">
            <g id="Group_8" data-name="Group 8" transform="translate(849.746 160.383)">
              <g id="Group_7" data-name="Group 7" transform="translate(-2 4)">
                <path id="Path_11" data-name="Path 11" d="M-201.6,78.559a1.407,1.407,0,0,1,1.368,1.448l-.018,7.206c-.022,2.487-2.585,4.928-4.338,6.965l-5.058,5.923a1.2,1.2,0,0,1-1.776,0l-5.058-5.947c-1.731-2.037-4.293-4.477-4.293-6.989l.018-7.168a1.406,1.406,0,0,1,1.368-1.438Z" fill="#35373d"/>
                <path id="Path_12" data-name="Path 12" d="M-210.539,101.974h-.035a2.6,2.6,0,0,1-1.991-.934l-5.041-5.925c-.26-.306-.538-.62-.824-.943-1.791-2.025-3.823-4.318-3.823-7.007l.018-7.172a2.894,2.894,0,0,1,2.851-2.915H-201.6a2.8,2.8,0,0,1,1.993.833,2.934,2.934,0,0,1,.858,2.1l-.018,7.205c-.024,2.688-2.081,4.99-3.9,7.021-.277.311-.548.614-.8.908l-5.055,5.919A2.654,2.654,0,0,1-210.539,101.974Zm.241-2.842.008.009Zm-9.086-19.09.1,7.127c0,1.561,1.636,3.408,3.078,5.038.3.338.592.668.864.988l4.817,5.663,4.818-5.643c.269-.311.551-.628.841-.953,1.466-1.641,3.129-3.5,3.142-5.063l.018-7.157Z" fill="#fff"/>
              </g>
            </g>
            <text id="risk_text" data-name="risk text" transform="translate(615.571 232.778)" fill="#35373d" font-size="10" font-weight="300"><tspan x="0" y="0">{text}</tspan></text>
          </g>
        </svg>
    )
}

/* 
{
    "ComponentClass": "CHART",
    "ComponentFamily": "BAR",
    "ComponentType": "SEGMENTED",
    "ComponentContent": {
        "Value": "76",
        "SecondaryValue": "",
        "LowerBounds": "0",
        "UpperBounds": "100",
        "LowerBoundLabel": "Lower Risk",
        "UpperBoundLabel": "Higher Risk",
        "SegmentNumber": "3",
        "Segments": [
            {
                "Label": "High Risk",
                "Color": "#FE9350",
                "UpperBounds": "40"
            },
            {
                "Label": "Medium Risk",
                "Color": "#FEC957",
                "UpperBounds": "70"
            },
            {
                "Label": "Low Risk",
                "Color": "#6CDE6C",
                "UpperBounds": "100"
            }
        ],
        "Label": "You are at low risk for breast cancer."
    },
    "ComponentVisible": "1"
}
*/